
<div class="container" style="margin-top: 2.5rem;">
  <app-business-banner #bannerRef (onAdd)="addTodo($event)"> </app-business-banner>
  <div style="margin-top: 1rem;">
    <!-- Left menu moved into the banner as tabs. Left column: admin tools in
         Admin View, company card for visitors / Member View. -->
    <div class="business-page-layout">

      <aside class="business-left" #leftCol *ngIf="bannerRef.businessData"
        [class.gs-biz-col-scroll]="useWidgetInnerScroll">
        <!-- Admin View: admin tools -->
        <app-business-admin-cards *ngIf="!showMemberCard(bannerRef.businessData)"
          [business]="bannerRef.bannerdata"
          (editProfile)="bannerRef.openProfileEdit()"
          (openEditor)="bannerRef.openProfileEditor($event)"
          (postJob)="postJob()"
          (manageEmployees)="openTab('employee-requests')"
          (analytics)="openTab('analytics')"
          (adminCenter)="openAdminCenter()"
          (uploadCover)="bannerRef.openCoverPicker()"
          (addServices)="openServicesEditor()">
        </app-business-admin-cards>

        <!-- Visitors / Member View: company card -->
        <app-business-member-card *ngIf="showMemberCard(bannerRef.businessData)"
          [business]="bannerRef.bannerdata"
          [admindata]="bannerRef.admindata"
          [businessData]="bannerRef.businessData"
          [logoSrc]="bannerRef.businesslogs?.src"
          (follow)="bannerRef.addfollower()"
          (unfollow)="bannerRef.removefollower()"
          (message)="bannerRef.mgsBtn()"
          (viewJobs)="openJobsTab()">
        </app-business-member-card>
      </aside>

      <div class="business-feed">
        <!-- outletAlive toggles off/on to remount the tab on a same-tab re-click -->
        <ng-container *ngIf="outletAlive">
          <router-outlet></router-outlet>
        </ng-container>
      </div>

      <!-- Wireframe sidebar (toggle: useWireframeSidebar = true): one sidebar
           on every tab incl. About. Same widgets on all tabs; admin vs member
           list is decided inside app-common-widget. -->
      <div class="business-widget gs-wf-sidebar" #rightCol *ngIf="useWireframeSidebar"
        [class.gs-biz-member-view]="showMemberCard(bannerRef.businessData)"
        [class.gs-biz-col-scroll]="useWidgetInnerScroll">
        <!-- Backend list for BUSINESS_HOME_PAGE; wireframeBusinessView switches on
             the fixed wireframe list + order inside app-common-widget. -->
        <app-common-widget [page]="'BUSINESS_HOME_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
          [viewByMember]=adminWidgets
          [wireframeBusinessView]="showMemberCard(bannerRef.businessData) ? 'MEMBER' : 'ADMIN'"
          [wireframeBusinessId]="bannerRef.businessData?.businessId">
        </app-common-widget>
      </div>

      <!-- Existing per-tab sidebar (toggle: useWireframeSidebar = false). Kept
           unchanged so the old behaviour can be switched back on. -->
      <div class="business-widget" #rightCol *ngIf="!useWireframeSidebar"
        [class.gs-biz-member-view]="showMemberCard(bannerRef.businessData)"
        [class.gs-biz-col-scroll]="useWidgetInnerScroll">
        <!-- About shows the same widgets as Home -->
        <ng-container *ngIf="isChildActive('/business/post') || isAboutUsRoute()">
          <!-- Profile Completion hidden here: it's in the left column (admin cards) -->
          <app-common-widget [page]="'BUSINESS_HOME_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets
            [hiddenWidgetIds]="['BUSINESS_PROFILE_COMPLETE', 'BUSINESS_COMPLETION']">
          </app-common-widget>
        </ng-container>


        <!-- this two not required now  we will add in feauture -->
        <ng-container *ngIf="isChildActive('/business/followerRequest-sent')">
        </ng-container>

        <ng-container *ngIf="isChildActive('/business/employee-requests')">
        </ng-container>


        <ng-container *ngIf="isChildActive('/business/follower')">
          <app-common-widget [page]="'BUSINESS_EMPLOYEE_REQ_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="isChildActive('/business/employee')">
          <app-common-widget [page]="'BUSINESS_EMPLOYEE_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>


        <ng-container *ngIf="isChildActive('/business/community')">
          <app-common-widget [page]="'BUSINESS_COMMUNITY_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="isChildActive('/business/analytics')">
          <app-common-widget [page]="'BUSINESS_ANALYTIC_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="isChildActive('/business/admin') || isChildActive('/business/business-settings')">
          <app-common-widget [page]="'BUSINESS_ADMIN_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="isChildActive('/business/deactivate')">
          <app-common-widget [page]="'BUSINESS_DEACTIVATE_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="isChildActive('/business/jobs')">
          <app-common-widget [page]="'BUSINESS_JOB_PAGE'" [inputData]="'BUSINESS'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
      </div>

    </div>
  </div>
</div>

<app-notifier [title]="notificationTitle" [message]="notificationContent"
  [executeShow]="businessNameEdited || businessLocationEdited"></app-notifier>
